/* eslint-disable */
import {
  GROUP_LIST_FETCH_COMPLETED,
  NETWORK_REQUEST_SENT,
  YEARS_FETCH_COMPLETED,
  TERMS_FETCH_COMPLETED,
  GROUP_FETCH_COMPLETED,
  GROUP_LIST_FETCH_STARTED,
  GROUP_LIST_REMOVE,
  WEEK_FETCH_COMPLETED,
  TEACHER_SCHEDULE_FETCH_COMPLETED,
  SET_GROUP_LOADING,
  SET_ALL_GROUP_LIST,
  SET_EXTRACT_DATA,
  SET_GROUP_LIST_VARIABLE_STUFF,
  SET_EDUCATION_YEAR_VARIABLE_STUFF,
  GROUP_JOURNAL_FETCH_COMPLETED
} from "./types";
import { buildDefaultHeaders } from "./helper";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { list as cathedras } from "./cathedra";
import { cathList } from "./cathedra";
import { list as faculties } from "./faculty";
import { checkAndUpdateToken } from "./auth";
import moment from "moment";

// TODO mto dashbord
export const schoolYear = () => async (dispatch, getState) => {
  dispatch({ type: SET_GROUP_LOADING, payload: true })
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/year/scy`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const result = await response.json();
    dispatch({ type: YEARS_FETCH_COMPLETED, list: result.schoolYear });
  }
  // }
  dispatch({ type: SET_GROUP_LOADING, payload: false })
};

export const getWeek = (year) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUP_LOADING, payload: true })
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/year/week/${year}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      const startWeekDate = moment()
        .startOf("week")
        .format("DD.MM.YYYY");
      const week = result.weekList.find(
        (item) => item.week_start === startWeekDate
      );
      const week2 = result.weekList.reverse().find( // первая неделя кривая 
        (item) => item
      );
      dispatch({
        type: WEEK_FETCH_COMPLETED,
        weekList: result.weekList,
        currentEdWeekId: week ? week.week_id : week2.week_id
      });
    } else {
      console.log({ response });
    }
  }
  dispatch({ type: SET_GROUP_LOADING, payload: false })
};

export const getTerms = (year) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/year/term/${year}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: TERMS_FETCH_COMPLETED,
        terms: result.terms,
      });
    } else {
      console.log(response);
    }
  }
};

export const getSchedule = (weekId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const mid = getState().auth.mid;

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/schedule/t/${mid}/${weekId}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: TEACHER_SCHEDULE_FETCH_COMPLETED,
        teacherSchedule: result.teacherSchedule,
      });
    } else {
      console.log({ response });
    }
  }
};

export const list = (yearId, facultyId, courseId) => async (
  dispatch,
  getState
) => {

  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_GROUP_LOADING, payload: true })
    if (facultyId && yearId && courseId) {
      dispatch({ type: GROUP_LIST_FETCH_STARTED });
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/group/0/${facultyId}/${yearId}/${courseId}`,
        buildDefaultHeaders(getState)
      );

      dispatch({ type: NETWORK_REQUEST_SENT, response });

      if (response.ok) {
        const result = await response.json();
        dispatch({
          type: GROUP_LIST_FETCH_COMPLETED,
          list: result,
          courseId,
          facultyId,
          yearId,
        });
      }
    }
    dispatch({ type: SET_GROUP_LOADING, payload: false })
  }
};

export const allData = () => async (dispatch) => {
  await dispatch(schoolYear());
  await dispatch(faculties());
  await dispatch(cathedras());
  dispatch(list());
};

export const group = (id) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/group/${id}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GROUP_FETCH_COMPLETED, group: data.group[0] });
    }
  }
};
// ProgressReport Журнал учета учебных занятий =  для групп
export const getGroupJournal = (year, term) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/group/journal/${year}/${term}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GROUP_JOURNAL_FETCH_COMPLETED, groupJournal: data });
    }
  }
};

export const getGroupList = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/group`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_ALL_GROUP_LIST, payload });
    }
  }
};
export const getGroupListVariableStuff = ({ year = 0, ...params }) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());

  if (getState().auth.token) {
    let urlParams = params;
    if (!urlParams.eyid || urlParams.eyid == 'all') { delete urlParams.eyid }
    if (!urlParams.idcathedra || urlParams.idcathedra == 'all') { delete urlParams.idcathedra }
    if (!urlParams.idfaculty || urlParams.idfaculty == 'all') { delete urlParams.idfaculty }
    urlParams = new URLSearchParams(urlParams).toString();

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/variable_composition/group/${year}?${urlParams}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_GROUP_LIST_VARIABLE_STUFF, payload });
    }
  }
};

export const getEducationYearVariableStuff = ({ xp_key, idfaculty, idcathedra }) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());

  if (getState().auth.token) {
    const params = {};
    if (xp_key) { params.xp_key = xp_key }
    if (idfaculty && idfaculty != 'all') { params.idfaculty = idfaculty }
    if (idcathedra && idcathedra != 'all') { params.idcathedra = idcathedra }
    const urlParams = new URLSearchParams(params).toString();

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/variable_composition/year/edy?${urlParams}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    // 404 = курсов нет, список надо очистить, а не оставить прошлый
    const payload = response.ok ? await response.json() : [];
    dispatch({ type: SET_EDUCATION_YEAR_VARIABLE_STUFF, payload });
  }
};

export const getExtract = (mid, trmid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    dispatch({ type: SET_GROUP_LOADING, payload: true })

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/schedule/vypiska/${mid}/${trmid}`,
      buildDefaultHeaders(getState)
    );

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_EXTRACT_DATA, payload: data.teacherScheduleVypiska });
    }
    dispatch({ type: SET_GROUP_LOADING, payload: false })
  }
};


export const groupRemove = () => ({ type: GROUP_LIST_REMOVE })
